import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  cityName: {},
  isLoading: false,
  error: "",
  hasData: false,
  cityNameStatus: {
    status: false,
    message: ""
  }
};
const cityNameSlice = createSlice({
  name: "cityNames",
  initialState,
  reducers: {
    cityNameRequest: state => {
      state.isLoading = true;
    },
    cityNameSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.cityName = action.payload;
      state.cityNameStatus.status = true;
    },
    cityNameFailure: (state, action) => {
      state.error = action.payload;
      state.cityName = "";
      state.isLoading = false;
      state.cityNameStatus.status = false;
    }
  }
});
export const {
  cityNameRequest,
  cityNameSuccess,
  cityNameFailure
} = cityNameSlice.actions;
export default cityNameSlice.reducer;